module.exports = __webpack_public_path__ + "/login_ui/img/aw-c3a4a47886c51603950e888c5b5a146b.svg";